module.exports = __webpack_public_path__ + "assets/img/img-hotel-15.98119527.jpg";